const MAX_RETRIES = 1;

const isAbortError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;
  const anyErr = error as { name?: unknown; code?: unknown };
  return anyErr.name === 'AbortError' || anyErr.code === 20;
}

export default async function fetchApiWrapperWithTimeout<T>(input: RequestInfo, init: RequestInit, timeout: number): Promise<T> {
  const fetchWithRetry = async (attempt = 0): Promise<Response> => {
    const controller = new AbortController();

    const id = setTimeout(() => {
      controller.abort();
    }, timeout);

    try {
      return await fetch(input, { ...init, signal: controller.signal });
    } catch (error) {
      if (attempt !== MAX_RETRIES && isAbortError(error)) {
        return fetchWithRetry(attempt + 1);
      }

      throw error;
    } finally {
      clearTimeout(id);
    }
  };

  const response = await fetchWithRetry();

  if (!response.ok) {
    return response
      .json()
      .then(data => {
        // eslint-disable-next-line
        throw { response, ...data };
      })
      .catch(data => {
        // eslint-disable-next-line
        throw { response, ...data };
      });
  }

  try {
    const data = await response.json();
    return data as T;
  } catch {
    return (response as unknown) as T;
  }
}
